
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaicabsonlinebooking() {



    const cardData =
    {
        keyword: 'Mumbai Cabs Online Booking',
        heading: 'Skyline Cabs: Mumbai Cabs Online Booking',
        headingDescription: '​Skyline Cabs offers comfortable and reliable Mumbai Cabs Online Booking services for all your group travel needs. Whether you are planning a family outing, corporate trip, or a special event, our well-maintained 7-seater vehicles and professional drivers ensure a smooth and enjoyable journey. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your 7-seater car rental with Skyline Cabs today and experience hassle-free group travel across Maharashtra and beyond!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Mumbai Cabs Online Booking",
      "description": "Skyline Cabs offers easy and quick online booking for cabs in Mumbai. Choose from a range of vehicles and book your ride in just a few clicks."
    },
    {
      "name": "Book Mumbai Taxi Online",
      "description": "Book your Mumbai taxi online with Skyline Cabs for a hassle-free and efficient booking experience. Available for city and outstation rides."
    },
    {
      "name": "Online Cab Booking in Mumbai",
      "description": "Skyline Cabs provides a smooth online cab booking platform in Mumbai. Instantly confirm your ride and enjoy comfortable travel."
    },
    {
      "name": "Mumbai Taxi Booking Service",
      "description": "Use Skyline Cabs' taxi booking service in Mumbai to reserve your cab quickly and conveniently, whether it's for personal or business travel."
    },
    {
      "name": "Mumbai Cab Reservation Online",
      "description": "Reserve your cab online in Mumbai with Skyline Cabs. Our platform offers flexible options, secure booking, and reliable service."
    },
    {
      "name": "Mumbai Outstation Cab Booking",
      "description": "Planning to travel outside Mumbai? Use Skyline Cabs for easy outstation cab booking with well-maintained vehicles and experienced drivers."
    }
  ],
  "tableData": [
    ["Mumbai Cabs Online Booking", "Book Mumbai Taxi Online"],
    ["Online Cab Booking in Mumbai", "Mumbai Taxi Booking Service"],
    ["Mumbai Cab Reservation Online", "Mumbai Outstation Cab Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai Cabs Online Booking",
      "WhyChoosedescription": "Book your Mumbai cab online with ease for a quick and hassle-free travel experience. Whether you need a ride for a business meeting, airport transfer, or a sightseeing tour, we’ve got you covered."
    },
    {
      "WhyChooseheading": "Easy and Convenient Online Booking",
      "WhyChoosedescription": "Our user-friendly online platform makes booking your Mumbai cab a breeze. Simply select your destination, pick your vehicle, and confirm your booking in just a few clicks."
    },
    {
      "WhyChooseheading": "Variety of Vehicles to Choose From",
      "WhyChoosedescription": "Choose from a wide range of vehicles, including sedans, SUVs, and luxury cars, to suit your travel needs and preferences, whether it's a solo trip or a group outing."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive rates with no hidden charges. Get upfront pricing and choose the option that fits your budget, ensuring a stress-free ride every time."
    },
    {
      "WhyChooseheading": "Experienced and Courteous Drivers",
      "WhyChoosedescription": "Our professional drivers are well-trained, punctual, and courteous, ensuring a smooth and safe journey while respecting your time and comfort."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "Every vehicle in our fleet is meticulously cleaned, sanitized, and regularly maintained to ensure the highest standards of comfort, hygiene, and safety."
    },
    {
      "WhyChooseheading": "24/7 Customer Support",
      "WhyChoosedescription": "Our customer support team is available 24/7 to assist with any booking inquiries, changes, or additional requests to make your journey seamless and worry-free."
    },
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "We pride ourselves on being punctual and dependable. Whether you’re traveling for business or leisure, you can rely on our cab service to get you to your destination on time."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab online in Mumbai with Skyline Cabs?',
            answer:
                'Booking a cab online with Skyline Cabs is easy. Simply visit our website or use our mobile app. Enter your pickup location, destination, travel date, and select your preferred vehicle. You’ll get an instant confirmation of your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for online booking in Mumbai?',
            answer:
                'We offer a variety of vehicles for online booking in Mumbai, including Sedans (Swift Dzire, Honda City), SUVs (Innova Crysta, Kia Carens), and 7-seater cars. We also offer Tempo Travellers and luxury coaches for larger groups.',
        },
        {
            id: 3,
            question: 'Is the online booking process safe and secure?',
            answer:
                'Yes, our online booking process is completely secure. We use trusted payment gateways for all transactions, ensuring that your personal and payment information is safe.',
        },
        {
            id: 4,
            question: 'Can I book a cab online for outstation travel from Mumbai?',
            answer:
                'Yes, you can easily book a cab online for outstation travel from Mumbai. Whether you are traveling to nearby cities like Pune, Lonavala, or even long-distance destinations, you can book your cab in advance.',
        },
        {
            id: 5,
            question: 'What payment options are available for online bookings?',
            answer:
                'For online bookings, we accept payments through UPI, credit/debit cards, net banking, and cash after the trip. All online transactions are processed through secure payment gateways.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my online cab booking?',
            answer:
                'Yes, you can easily modify or cancel your online booking via our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 7,
            question: 'Is there an option for round-trip bookings online?',
            answer:
                'Yes, you can book a round-trip cab online. Simply select the round-trip option while booking, and you’ll be able to specify your return details as well.',
        },
        {
            id: 8,
            question: 'Are there any discounts or offers for online bookings?',
            answer:
                'Skyline Cabs occasionally offers discounts and special promotions for online bookings. You can check our website or mobile app for the latest offers and promotions before confirming your booking.',
        },
        {
            id: 9,
            question: 'How do I receive confirmation for my online cab booking?',
            answer:
                'Once your booking is confirmed, you will receive an email or SMS with all the details, including the driver’s contact information, vehicle type, and estimated pickup time.',
        },
        {
            id: 10,
            question: 'Why should I book a cab online with Skyline Cabs?',
            answer:
                'Skyline Cabs offers a convenient, fast, and secure online booking experience. With transparent pricing, well-maintained vehicles, and reliable customer service, you can book your cab with confidence and enjoy a smooth, hassle-free journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rajesh Kumar",
            rating: 5,
            review: "Booked a cab online through the Skyline Cabs website. The process was smooth and easy. The driver arrived on time, and the ride was comfortable. Highly recommend their online booking service!"
        },
        {
            name: "Miss. Aarti Mehra",
            rating: 4,
            review: "Used the mobile app to book a cab for a trip to the airport. The booking process was straightforward, but I faced a small issue with payment. However, customer support was prompt and resolved it quickly."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Cabs Online Booking",
  "image": "https://skylinecabs.com/assets/images/mumbai-cabs-online-booking.jpg",
  "description": "Book Mumbai cabs online with Skyline Cabs for fast, reliable, and affordable taxi service across the city and outstation routes. Choose from sedans, SUVs, and luxury vehicles with 24/7 availability and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "9021"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-cabs-online-booking"
  }
};



      
      


    return (
        <div>

<Helmet>
  <title>Mumbai Cabs Online Booking | 24/7 Taxi Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai cabs online with Skyline Cabs for fast, reliable, and affordable taxi service across the city and outstation routes. Choose from sedans, SUVs, and luxury vehicles with 24/7 availability and professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Cabs Online Booking, Online Taxi Booking Mumbai, 24/7 Cab Mumbai, Mumbai Outstation Taxi Booking, Sedan Cab Mumbai, SUV Cab Hire in Mumbai, Luxury Cab Mumbai Online, Instant Cab Booking Mumbai, Skyline Cabs Mumbai Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/96.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaicabsonlinebooking;